<template>
  <div class="osd-dropdown">
    <header class="osd-dropdown__hero">
      <div class="osd-dropdown__hero-glow" aria-hidden="true" />
      <div class="osd-dropdown__hero-top">
        <span class="osd-dropdown__hero-badge" aria-hidden="true">
          <v-icon icon="mdi-cog-outline" size="18" />
        </span>
        <div class="osd-dropdown__hero-text">
          <h2 class="osd-dropdown__title">Organization Settings</h2>
          <p class="osd-dropdown__subtitle">Configure your workspace</p>
        </div>
        <span class="osd-dropdown__count">{{ filteredCategories.length }}</span>
      </div>

      <div class="osd-dropdown__search" :class="{ 'osd-dropdown__search--focused': searchFocused }">
        <v-icon
          class="osd-dropdown__search-icon"
          icon="mdi-magnify"
          size="17"
        />
        <input
          ref="searchInput"
          class="osd-dropdown__search-input"
          type="search"
          :value="search"
          placeholder="Search settings…"
          autocomplete="off"
          @focus="searchFocused = true"
          @blur="searchFocused = false"
          @input="$emit('update:search', $event.target.value)"
        />
        <button
          v-if="search"
          type="button"
          class="osd-dropdown__search-clear"
          aria-label="Clear search"
          @click="clearSearch"
        >
          <v-icon icon="mdi-close" size="14" />
        </button>
      </div>
    </header>

    <div v-if="filteredCategories.length" class="osd-dropdown__scroll">
      <ul class="osd-dropdown__list">
        <li
          v-for="(category, index) in filteredCategories"
          :key="category.id"
          class="osd-dropdown__item"
          :style="{ '--osd-stagger': `${index * 28}ms` }"
        >
          <button
            type="button"
            class="osd-dropdown__card"
            :class="{ 'osd-dropdown__card--active': category.id === activeId }"
            @click="$emit('select', category.id)"
          >
            <span
              class="osd-dropdown__icon-well"
              :class="`osd-dropdown__icon-well--${category.accent}`"
            >
              <v-icon
                :icon="category.icon || 'mdi-cog-outline'"
                size="17"
              />
            </span>
            <span class="osd-dropdown__text">
              <span class="osd-dropdown__name">{{ category.title }}</span>
              <span class="osd-dropdown__desc">{{ category.description }}</span>
            </span>
            <v-icon
              class="osd-dropdown__arrow"
              icon="mdi-arrow-right"
              size="16"
            />
          </button>
        </li>
      </ul>
    </div>

    <div v-else class="osd-dropdown__empty">
      <span class="osd-dropdown__empty-icon" aria-hidden="true">
        <v-icon icon="mdi-magnify-close" size="22" />
      </span>
      <span class="osd-dropdown__empty-title">No settings found</span>
      <span class="osd-dropdown__empty-hint">Try a different search term</span>
    </div>

    <footer v-if="filteredCategories.length" class="osd-dropdown__footer">
      <span>Select a category to configure</span>
    </footer>
  </div>
</template>

<script>
import { filterOrganizationCategories } from "@/constants/organizationSettingsNav.js";

export default {
  name: "OrgSettingsDropdownPanel",
  props: {
    search: { type: String, default: "" },
    categories: { type: Array, default: () => [] },
    activeId: { type: String, default: "" },
  },
  emits: ["update:search", "select"],
  data() {
    return {
      searchFocused: false,
    };
  },
  computed: {
    filteredCategories() {
      return filterOrganizationCategories(this.categories, this.search);
    },
  },
  methods: {
    clearSearch() {
      this.$emit("update:search", "");
      this.$refs.searchInput?.focus();
    },
  },
};
</script>
